<nb-card>
  <nb-card-header>
    <nav class="navbar navigation">
      <h2>Custom Forms</h2>
      <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
      </button>

    </nav>

  </nb-card-header>

  <nb-card-body>
    <ng2-smart-table [settings]="settings" [source]="source" >
    </ng2-smart-table>
  </nb-card-body>
</nb-card>
